import "./App.css";
import {
  Routes,
  BrowserRouter as Router,
  Route,
  Navigate,
} from "react-router-dom";
import DashBoardGraph from "./components/dashBoardGraph/DashBoardGraph";
import AdminDashBoard from "./components/adminDashBoard/AdminDashBoard";
import CreatorActivity1 from "./components/creatorActivity1/CreatorActivity1";
import Activity from "./components/Activity2";
import UploadMedia from "./components/UploadMedia";
import UploadMedia1 from "./components/UploadMedia1";
import Submission from "./components/Submission";
import Submission1 from "./components/Submission1";
import Credentials from "./components/credentials/Credentials";
import Credentials1 from "./components/credentials1/Credentials";
import EtheriumLogin from "./components/etheriumLogin/EtheriumLogin";
import Signup from "./components/Signup/Signup";
import Main from "./components/Main/Main";
function App() {
  return (
    <Router basename="/">
      <Routes>
        <Route path={`/`} element={<Main />} />
        <Route path={`/admin`} element={<AdminDashBoard />} />
        <Route path={`/login`} element={<EtheriumLogin />} />
        <Route path={`/signup`} element={<Signup />} />
        <Route path={`/graph`} element={<DashBoardGraph />} />
        <Route path={`/creator/creator1`} element={<CreatorActivity1 />} />
        <Route path={`/creator`} element={<Activity />} />
        <Route path={`/creator/UploadMedia`} element={<UploadMedia />} />
        <Route path={`/creator/UploadMedia1`} element={<UploadMedia1 />} />
        <Route path={`/creator/Submission`} element={<Submission />} />
        <Route path={`/standard/Submission1`} element={<Submission1 />} />
        <Route path={`/portfolio`} element={<Credentials />} />
        <Route path={`/standard`} element={<Credentials1 />} />
      </Routes>
    </Router>
  );
}
export default App;
